var React = require('react');

function ThreeDot (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"3.5","r":"1.5","fill":"white","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"1.5","fill":"white","key":1}),React.createElement("circle",{"cx":"8","cy":"12.5","r":"1.5","fill":"white","key":2})]);
}

ThreeDot.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ThreeDot;

ThreeDot.default = ThreeDot;
